<template>
    <div class="page">
        <box fill>
            <el-form label-position="right" label-width="80px" class="EL-Form">
                <el-col :lg="5" :xl="5">
                    <el-form-item label="权限编号" class="EL-Form-Item">
                        <el-input placeholder="请输入" v-model="pagination.authCode" @change="saveSearch()">
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="权限名称" class="EL-Form-Item">
                        <el-input placeholder="请输入" v-model="pagination.authName" @change="saveSearch()">
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="所属系统" class="EL-Form-Item">
                        <el-input placeholder="请输入" v-model="pagination.authSystem" @change="saveSearch()">
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="4" :xl="4">
                    <el-form-item class="btn-edit-delete EL-Form-Item">
                        <el-button class="btn-t-edit" @click="getAuxiMaterialData()">
                            查询
                        </el-button>
                        <el-button class="btn-t-delete" @click="resetData()">
                            重置
                        </el-button>
                    </el-form-item>
                </el-col>
            </el-form>
            <el-divider></el-divider>
            <plabel text="权限列表">
                <el-button v-authority="'BACK_MENU8_M3_B1'" class="btn-t-edit" @click="(add_or_edit = true), (editBoxShow = true)">新增</el-button>
            </plabel>
            <!-- 展示 -->
            <h-table :headerCellStyle="headerCellStyle" style="flex: 1" @pageChange="getAuxiMaterialData" :data="mainData" pagination :nowPage.sync="pagination.pageNum" :pageSize.sync="pagination.pageSize" :total.sync="pagination.total">
                <!-- <el-table-column prop="authId" label="序号" /> -->
                <el-table-column prop="authCode" label="权限编号" />
                <el-table-column prop="authName" label="权限名称" />
                <el-table-column prop="parentId" label="父权限" />
                <el-table-column prop="authLevel" label="权限等级" />
                <el-table-column prop="authView" label="所属页面" />
                <el-table-column prop="authSystem" label="所属系统" />
                <el-table-column prop="authType" label="类型" />
                <el-table-column prop="note" label="备注" />
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <el-button v-authority="'BACK_MENU8_M3_B2'" size="mini" type="primary" @click="
                (add_or_edit = false),
                  (editBoxShow = true),
                  (mainObj = JSON.parse(JSON.stringify(scope.row)))
              " plain icon="el-icon-edit-outline" />
                        <el-button v-authority="'BACK_MENU8_M3_B3'" type="danger" @click="deleteRow(scope.row.authId)" size="mini" plain icon="el-icon-delete" />
                    </template>
                </el-table-column>
            </h-table>
        </box>

        <!-- 新增&&编辑框 -->
        <el-dialog :title="add_or_edit ? '新增' : '编辑'" :close-on-click-modal="false" :visible.sync="editBoxShow" width="700px" :model="mainObj" @open="open">
            <span class="formClass">
                <el-form :inline="true" label-position="top" label-width="80px" :model="mainObj" :rules="rules" ref="mainObj">
                    <!-- <cascadeSearch ref="cascadeSearch" :f.sync="mainObj.fcCode" :w.sync="mainObj.shopCode" @change="queryMainData(),mainObj.sectionCode = ''" /> -->
                    <el-form-item label="权限编号" prop="authCode">
                        <el-input v-model="mainObj.authCode"> </el-input>
                    </el-form-item>
                    <el-form-item label="权限名称" prop="authName">
                        <el-input v-model="mainObj.authName"> </el-input>
                    </el-form-item>
                    <el-form-item label="所属页面" prop="authView">
                        <el-input v-model="mainObj.authView"> </el-input>
                    </el-form-item>
                    <el-form-item label="所属系统" prop="authSystem">
                        <el-input v-model="mainObj.authSystem"> </el-input>
                    </el-form-item>
                    <el-form-item label="父权限" prop="parentId">
                        <el-input v-model="mainObj.parentId" oninput="value=value.replace(/[^\d]/g,'')">
                        </el-input>
                    </el-form-item>
                    <el-form-item label="类型" prop="authType">
                        <el-select v-model="mainObj.authType" placeholder="请选择">
                            <el-option label="menu" value="menu" />
                            <el-option label="button" value="button" />
                        </el-select>
                    </el-form-item>
                    <el-form-item label="备注" prop="note">
                        <el-input v-model="mainObj.note"> </el-input>
                    </el-form-item>
                </el-form>
            </span>
            <span slot="footer" class="dialog-footer">
                <el-button size="small" type="info" @click="close()">
                    取 消
                </el-button>
                <el-button size="small" type="primary" v-if="add_or_edit" @click="add">
                    新 增
                </el-button>
                <el-button size="small" type="primary" v-else @click="editRow">
                    修 改
                </el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        name: "AuxiMaterial",
        data() {
            return {
                headerCellStyle: () => {
                    return "background-color: #1f5cec";
                },
                form: {},
                rules: {
                    authName: [{
                        required: true,
                        message: "请输入",
                        trigger: "blur",
                    }, ],
                    authCode: [{
                        required: true,
                        message: "请输入",
                        trigger: "blur",
                    }, ],
                    authType: [{
                        required: true,
                        message: "请输入",
                        trigger: "blur",
                    }, ],
                    authSystem: [{
                        required: true,
                        message: "请输入",
                        trigger: "blur",
                    }, ],
                    parentId: [{
                        required: true,
                        message: "请输入",
                        trigger: "blur",
                    }, ],
                    // note: [{
                    // required: true,
                    // message: '请输入',
                    // trigger: 'blur'
                    // }],
                },
                mainLine: {
                    authId: null,
                    authName: "",
                    authCode: "",
                    authView: "",
                    authSystem: "",
                    parentId: "",
                    note: "",
                    createTime: "",
                    updateTime: "",
                },
                mainObj: {},
                add_or_edit: Boolean, //新增|编辑
                loading: 0, //加载中
                editBoxShow: false, //编辑框
                EditDialogVisible: false,
                formLabelWidth: "270px",
                tableHeight: 0, //表格高度
                // 分页
                pagination: {
                    pageNum: 1,
                    pageSize: 50,
                    total: 0,
                    authCode: "",
                    authName: "",
                    authSystem: "",
                },
                // 页面展示主信息
                mainData: [{
                    authId: null,
                    authName: "",
                    authCode: "",
                    authView: "",
                    authSystem: "",
                    parentId: "",
                    note: "",
                    createTime: "",
                    updateTime: "",
                }, ],

                logContent: "", //操作日志-内容
                logRemarks: "", //操作日志-备注
                // 输入框延时加载
                isSetTimeout: null,
            };
        },
        watch: {
            pagination: {
                handler(newVal) {
                    clearTimeout(this.isSetTimeout)
                    this.isSetTimeout = setTimeout(() => {
                        this.getAuxiMaterialData(newVal);
                    },1000)
                },
                deep: true,
            },
        },
        methods: {
            close() {
                this.editBoxShow = false;
                this.mainObj = {}
            },
            // 节流搜索
            saveSearch() {
                if (window.lazy) window.clearTimeout(window.lazy)
                window.lazy = window.setTimeout(() => {
                    this.getAuxiMaterialData()
                }, 1000)
            },
            //获取数据
            getAuxiMaterialData() {
                this.$http
                    .request({
                        url: "/api/authority/getAuthorityAll",
                        method: "GET",
                        params: {
                            pageNum: this.pagination.pageNum,
                            pageSize: this.pagination.pageSize,
                            authCode: this.pagination.authCode,
                            authName: this.pagination.authName,
                            authSystem: this.pagination.authSystem,
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.mainData = resp.data.list || [];
                            this.pagination.total = resp.data.total;
                        }
                    })
                    .catch((error) => {});
            },

            //表单验证
            submitForm(formName) {
                let r = Boolean;
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        r = true;
                    } else {
                        r = false;
                    }
                });
                return r;
            },
            //框打开
            open() {
                if (this.add_or_edit) {
                    //新增
                    this.mainObj = JSON.parse(
                        JSON.stringify({
                            authId: null,
                            authName: "",
                            authCode: "",
                            authView: "",
                            authSystem: "",
                            parentId: "",
                            note: "",
                            createTime: "",
                            updateTime: "",
                        })
                    );
                } else {
                    this.getAuxiMaterialData();
                }
            },
            //新增
            add() {
                if (this.submitForm("mainObj")) {
                    this.$http
                        .request({
                            url: "/api/authority/insertAuthority",
                            method: "POST",
                            showLoading: true,
                            data: this.mainObj,
                        })
                        .then((resp) => {
                            if (resp.status == 100) {
                                this.$notify({
                                    title: "成功",
                                    message: "新增成功！",
                                    type: "success",
                                });
                                this.logRemarks = "authority：权限新增成功";
                            } else {
                                this.$notify.error({
                                    title: "失败",
                                    message: resp.message,
                                });
                                this.logRemarks = "authority：权限新增失败";
                            }
                            this.logContent = "authCode：" + this.mainObj.authCode;
                            this.systemLog();
                            this.editBoxShow = false;
                            this.getAuxiMaterialData();
                        })
                        .catch((error) => {
                            this.$notify.error({
                                title: "失败",
                                message: "调用失败",
                            });
                        });
                }
            },
            //编辑
            editRow() {
                if (this.submitForm("mainObj")) {
                    this.$http
                        .request({
                            url: "/api/authority/updateAuthority",
                            method: "PUT",
                            showLoading: true,
                            data: this.mainObj,
                        })
                        .then((resp) => {
                            if (resp.status == 100) {
                                this.$notify({
                                    title: "成功",
                                    message: "修改成功！",
                                    type: "success",
                                });
                                this.logRemarks = "authority：权限修改成功";
                            } else {
                                this.$notify.error({
                                    title: "失败",
                                    message: resp.message,
                                });
                                this.logRemarks = "authority：权限修改失败";
                            }
                            this.logContent = "authCode：" + this.mainObj.authCode;
                            this.systemLog();
                            this.editBoxShow = false;
                            this.getAuxiMaterialData();
                        })
                        .catch((error) => {
                            this.$notify.error({
                                title: "失败",
                                message: "调用失败",
                            });
                        });
                }
            },
            //删除
            deleteRow(authId) {
                this.$confirm("此操作将删除该数据, 是否继续?", "提示", {
                        confirmButtonText: "删除",
                        cancelButtonText: "取消",
                        type: "warning",
                    })
                    .then(() => {
                        this.$http
                            .request({
                                url: "/api/authority/deleteAuthority",
                                method: "DELETE",
                                showLoading: true,
                                params: {
                                    authId: authId,
                                    // data: this.nowDateTime()
                                },
                            })
                            .then((resp) => {
                                if (resp.status == 100) {
                                    this.$notify({
                                        title: "成功",
                                        message: "删除成功！",
                                        type: "success",
                                    });
                                    this.logRemarks = "authority：权限删除成功";
                                } else {
                                    this.$notify.error({
                                        title: "失败",
                                        message: resp.message,
                                    });
                                    this.logRemarks = "authority：权限删除成功";
                                }
                                this.logContent = "authId：" + authId;
                                this.systemLog();
                                this.getAuxiMaterialData();
                            })
                            .catch((error) => {
                                this.$notify.error({
                                    title: "失败",
                                    message: "调用失败",
                                });
                            });
                    })
                    .catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消删除",
                        });
                    });
            },

            //重置
            resetData() {
                this.pagination = {
                    pageNum: 1,
                    pageSize: 50,
                    total: 0,
                    authCode: "",
                    authName: "",
                    authSystem: "",
                };
                this.getAuxiMaterialData();
            },

            /**
             * 操作日志
             */
            systemLog() {
                let objData = {
                    logType: "权限管理",
                    logContent: this.logRemarks || "",
                    //logRemarks: this.logRemarks || "",
                    logUser: localStorage.getItem("user") || "",
                };
                this.$http
                    .request({
                        url: "api/log/insert",
                        method: "POST",
                        data: objData,
                    })
                    .then((resp) => {
                        this.logContent = "";
                        this.logRemarks = "";
                        if (resp.status == 100) {}
                    })
                    .catch((error) => {});
            },
        },
        activated(){
            /* 获取首页的数据 */
            this.getAuxiMaterialData();
        },
    };
</script>

<style scoped>
</style>